import { useEffect, useState } from 'react';

export type ParticipantTheme = 'dark' | 'light';

const STORAGE_KEY = 'participant-theme';

function readStored(): ParticipantTheme {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'dark' || stored === 'light') return stored;
  } catch {
    // localStorage unavailable (private browsing etc.) — fall through to default
  }
  return 'dark';
}

// Dark is the default — this experience has always been dark-themed (a
// deliberate "war room" look for the exercise), so an unset preference must
// keep behaving exactly as before rather than silently switching everyone
// to light on first load.
export function useParticipantTheme(): [ParticipantTheme, (theme: ParticipantTheme) => void] {
  const [theme, setThemeState] = useState<ParticipantTheme>(readStored);

  const setTheme = (next: ParticipantTheme) => {
    setThemeState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // ignore — theme just won't persist across reloads
    }
  };

  useEffect(() => {
    document.documentElement.style.colorScheme = theme;
  }, [theme]);

  return [theme, setTheme];
}
